// partOps — what can be done to one part of a container on the Studio canvas
// (open it, move it in the reading order, take it out), and where a dragged
// part lands. Pure.

export type { PartIntent };
export { moveTarget, reorderTarget };

// One part's intent; `part` is its resource id, places are 0-based.
type PartIntent =
    | { readonly type: "open"; readonly part: string }
    | {
          readonly type: "move";
          readonly part: string;
          readonly from: number;
          readonly to: number;
      }
    | { readonly type: "remove"; readonly part: string; readonly at: number };

// Move up / Move down: the neighbouring place, or none at either end.
const moveTarget = (
    from: number,
    count: number,
    direction: "up" | "down",
): number | undefined => {
    const to = direction === "up" ? from - 1 : from + 1;
    return to < 0 || to >= count ? undefined : to;
};

// The place a dragged part takes when released at `y`: one past every other
// row whose middle is above the pointer. `middles` are the rows' vertical
// middles in reading order (the dragged one at `from` included).
const reorderTarget = (
    middles: readonly number[],
    from: number,
    y: number,
): number => middles.filter((m, i) => i !== from && m < y).length;
